import { useEffect, useState } from "react";

import styles from "../styles/mensageria.module.scss";

import { ProvidersConfigurationDrawer } from "../shared/containers/mensageria/ProvidersConfigurationDrawer";
import { WhatsAppDrawer } from "../shared/containers/mensageria/whatsapp/WhatsAppDrawer";

import { Button } from "../shared/components/Button";
import { Checkbox } from "../shared/components/Checkbox";
import { Drawer } from "../shared/components/Drawer";
import { Empty } from "../shared/components/Empty";
import { Hairline } from "../shared/components/Hairline";
import { Input } from "../shared/components/Input";
import { Label } from "../shared/components/Label";
import { Title } from "../shared/components/Title";
import { If } from "../shared/components/control-statements";
import { Environment } from "../shared/core/Environment";

import { OlgaEnvironmentsAPI } from "../providers/OlgaEnvironmentsAPI";

import { Email } from "@tools/Email";

import { Loading } from "@components";
import classNames from "classnames/bind";
import { Icon } from "../shared/components/core/Icon";
const css = classNames.bind(styles);

const MESSENGER_PROVIDERS = {
  INFOBIP: {
    name: "InfoBip",
    alias: "infobip",
    active: false,
    fields: {
      apiKey: "Chave da API",
      baseUrl: "URL Base",
    },
  },
  ONESIGNAL: {
    name: "OneSignal",
    alias: "onesignal",
    active: false,
    fields: {
      apiKey: "Chave da API",
    },
  },
};

export default function Message() {
  const [openConfigure, setOpenConfigure] = useState(false);
  const [loading, setLoading] = useState(true);
  const [configuredMessaging, setConfiguredMessaging] = useState(false);
  const [messenger, setMessenger] = useState(null);

  const [openConfigureEmail, setOpenConfigureEmail] = useState(false);
  const [configuredEmail, setConfiguredEmail] = useState(false);
  const [email, setEmail] = useState(null);

  const [openConfigurePush, setOpenConfigurePush] = useState(false);
  const [configuredPush, setConfiguredPush] = useState(false);
  const [push, setPush] = useState(null);

  const [openConfigureWhatsapp, setOpenConfigureWhatsapp] = useState(false);
  const [configuredWhatsapp, setConfiguredWhatsApp] = useState(false);

  useEffect(() => {
    const environmentConfigurations = Environment.configurations;
    if (!messenger && environmentConfigurations) {
      const { services, push, email, whatsapp } = environmentConfigurations;

      const providers = Object.values(MESSENGER_PROVIDERS).map((provider) => {
        return {
          ...provider,
          values: services?.[provider.alias],
        };
      });

      if (!services) {
        const defaultServicesObj = {};
        providers.map((provider) => {
          const { fields, alias } = provider;
          defaultServicesObj[alias] = {};
          Object.keys(fields).map((field) => {
            defaultServicesObj[alias][field] = null;
          });
        });
        setMessenger(defaultServicesObj);
        setLoading(false);
      } else {
        setMessenger(services);
        setLoading(false);
      }

      providers.map((provider) => {
        const { fields, values } = provider;

        if (fields && values) {
          const providerFields = Object.keys(fields);
          const invalidFields = providerFields.find(
            (field) => values[field]?.length <= 3
          );
          if (!invalidFields) {
            setConfiguredMessaging(true);
            setLoading(false);
          }
        }
      });

      const { onesignal } = push || { onesignal: {} };
      const { appId } = onesignal || {};
      if (appId) {
        setPush(push);
        setConfiguredPush(true);
        setLoading(false);
      }

      const { sender: emailSender } = email || {};
      if (emailSender) {
        setEmail(email);
        setConfiguredEmail(true);
        setLoading(false);
      }

      const { sender: whatsappSender } = whatsapp || {};
      if (whatsappSender) {
        setConfiguredWhatsApp(true);
        setLoading(false);
      }
    }
  }, []);

  const onSavePush = async () => {
    if (!push) {
      return false;
    }

    setLoading(true);
    const saveReq = await OlgaEnvironmentsAPI.putConfigurations({
      push,
    });

    if (saveReq.getErrors([]).length === 0) {
      await Environment.installConfigurations();
      setOpenConfigurePush(false);
      setConfiguredPush(true);
    }
    setLoading(false);
  };

  const onSaveEmail = async () => {
    if (!email?.sender) {
      return false;
    }

    setLoading(true);
    const saveReq = await OlgaEnvironmentsAPI.putConfigurations({
      email,
    });

    if (saveReq.getErrors([]).length === 0) {
      await Environment.installConfigurations();
      setOpenConfigureEmail(false);
      setConfiguredEmail(true);
    }
    setLoading(false);
  };

  return (
    <>
      <If cond={loading}>
        <div className={styles.loading}>
          <Loading />
        </div>
      </If>

      <If cond={!loading}>
        <Title title="Mensageria" backTo={{ url: "/fidelizacao-e-marketing", name: "Fidelização e Marketing" }}>
          <If cond={configuredMessaging}>
            <Button onClick={() => setOpenConfigure(true)} className={"ml-15"}>
              Editar
            </Button>
          </If>
        </Title>

        <If cond={!configuredMessaging && !loading}>
          <Empty>
            <Icon name="paper-plane" size="4x" regular />
            <p>Mensagem não configurada</p>
            <span>
              Por meio desta ferramenta, será possível configurar os disparos do
              sistema.
            </span>
            <Button design="primary" onClick={() => setOpenConfigure(true)}>
              Configurar
            </Button>
          </Empty>
        </If>

        <If cond={configuredMessaging}>
          <div className={styles.grid}>
            <div
              className={styles.card}
              onClick={() => setOpenConfigureWhatsapp(true)}
            >
              <div className={styles.header}>
                <div className="d-flex align-center">
                  <div className={styles.icon}>
                    <Icon name="whatsapp" brand size="1x" />
                  </div>
                  <p className={styles.name}>WhatsApp</p>
                </div>
                <div className={styles.chevron}>
                  <Icon name="chevron-right" regular size="1x" />
                </div>
              </div>
              <div
                className={css({
                  status: true,
                  configured: configuredWhatsapp,
                })}
              >
                {configuredWhatsapp ? "Ativado" : "Desativado"}
              </div>
            </div>

            <div
              className={styles.card}
              onClick={() => setOpenConfigureEmail(true)}
            >
              <div className={styles.header}>
                <div className="d-flex align-center">
                  <div className={styles.icon}>
                    <Icon name="envelope-open" size="1x" />
                  </div>
                  <p className={styles.name}>E-mail</p>
                </div>
                <div className={styles.chevron}>
                  <Icon name="chevron-right" regular size="1x" />
                </div>
              </div>
              <div
                className={css({
                  status: true,
                  configured: configuredEmail,
                })}
              >
                {configuredEmail ? "Ativado" : "Desativado"}
              </div>
            </div>

            <div
              className={styles.card}
              onClick={() => setOpenConfigurePush(true)}
            >
              <div className={styles.header}>
                <div className="d-flex align-center">
                  <div className={styles.icon}>
                    <Icon name="message" size="1x" />
                  </div>
                  <p className={styles.name}>Push</p>
                </div>
                <div className={styles.chevron}>
                  <Icon name="chevron-right" regular size="1x" />
                </div>
              </div>
              <div
                className={css({
                  status: true,
                  configured: configuredPush,
                })}
              >
                {configuredPush ? "Ativado" : "Desativado"}
              </div>
            </div>
          </div>
        </If>
      </If>

      <If cond={openConfigure}>
        <ProvidersConfigurationDrawer
          onClose={() => setOpenConfigure(false)}
          messenger={messenger}
          setMessenger={(value) => setMessenger(value)}
          setConfiguredMessaging={(value) => setConfiguredMessaging(value)}
        />
      </If>

      <Drawer
        visible={openConfigureEmail}
        onClose={() => setOpenConfigureEmail(false)}
        title="Email"
        footer={
          <Button
            text="Salvar"
            design="primary"
            className="w-100"
            loading={loading}
            disabled={
              !email?.sender ||
              (email?.allowMultipleSender &&
                !Email.validDomain(email?.senderDomain))
            }
            onClick={() => {
              onSaveEmail();
            }}
          />
        }
      >
        <Label>Insira o remetente</Label>
        <Input
          placeholder="Remetente"
          value={email?.sender}
          onChange={(e) => setEmail({ ...email, sender: e.target.value })}
        />
        <Hairline className="mt-20 mb-20" />

        <Label>Múltiplos remetentes</Label>
        <Checkbox
          label={"Permitir múltiplos remetentes"}
          checked={email?.allowMultipleSender}
          onChange={(e) =>
            setEmail({
              ...email,
              allowMultipleSender: !email?.allowMultipleSender,
            })
          }
        />
        <If cond={email?.allowMultipleSender}>
          <Input
            prefix="Domínio"
            prefixWidth={100}
            placeholder="seudominio.com.br"
            className="mt-20"
            value={email?.senderDomain}
            onChange={(e) =>
              setEmail({ ...email, senderDomain: e.target.value })
            }
          />
        </If>
      </Drawer>

      <Drawer
        visible={openConfigurePush}
        onClose={() => setOpenConfigurePush(false)}
        title="Push"
        footer={
          <Button
            text="Salvar"
            design="primary"
            className="w-100"
            loading={loading}
            disabled={!push?.onesignal?.appId}
            onClick={() => {
              onSavePush();
            }}
          />
        }
      >
        <Label>Insira a identificação do app</Label>
        <Input
          placeholder="Identificação do app"
          value={push?.onesignal?.appId}
          onChange={(e) =>
            setPush({
              ...push,
              onesignal: { ...push?.onesignal, appId: e.target.value },
            })
          }
        />
      </Drawer>

      <If cond={openConfigureWhatsapp}>
        <WhatsAppDrawer
          open={openConfigureWhatsapp}
          onClose={() => setOpenConfigureWhatsapp(false)}
          onConfiguredWhatsApp={() => setConfiguredWhatsApp(true)}
        />
      </If>
    </>
  );
}
